import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import {TextMaskModule} from 'angular2-text-mask';





import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import {ListingService } from '../../listing.service';

@Component({
  selector: 'edit-admin-profile',
  templateUrl: './edit-admin-profile.component.html',
  styleUrls: ['./edit-admin-profile.component.css','../../admin.css','../../../app.component.css'],
  providers: [ListingService]
})
export class EditAdminProfileComponent implements OnInit {

  info:any;
  users:any;
  public spinner: boolean = false;
  htmlVariable = '';
  phoneMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];


  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<EditAdminProfileComponent>, private formBuilder: FormBuilder, private ListingService: ListingService,private snackBar: MdSnackBar) {
    this.users = {
      firstName : '',
      lastName : '',
      email : '',
      cellPhone : '',
      userId:''}
  }

  ngOnInit() {
    this.users = {
      firstName: this.info.firstName,
      lastName: this.info.lastName,
      email: this.info.email,
      cellPhone: this.info.cellPhone,
      userId: this.info.userId,
    }

  }

  editAdmin(adminForm){
    //console.log(this.FormValid(attendeeForm));
    if(adminForm.valid && this.FormValid(adminForm)){
      this.spinner = true;
      this.ListingService.updateAdmin({ users:this.users}).subscribe(
              response => {
            this.spinner = false;
            if(response.status)
            {
              this.dialogRef.close(response);
            }
            else{
              this.spinner = false;
              this.snackBar.open(response.message,'',{duration:4000});
            }
          },
              error => {
            this.spinner = false;
          }
      );
    }
  }


  FormValid(Id){
    var flag = true;

      if(flag  && !this.validateEmail(this.users.email))
      {
        flag = false;
      }
      if(flag && !this.validatePhone(this.users.cellPhone))
      {
        flag = false;
      }

    if(flag && !this.users.firstName)
    {
      flag = false;
    }
    if(flag && !this.users.lastName)
    {
      flag = false;
    }

    return flag;

  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone){
    var re = /^[0-9]{10}$/;
    return re.test(phone.replace(/-/g, ""));
  }

  close() {
    this.dialogRef.close('');
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/profile/edit/edit-admin-profile.component.ts